
import '../Services.css';
import img from '../../../assets/catogory/rent/img2.jpg'; // Using distinct image for Rental
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const RentalServices = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Rental Services</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Rental Services</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of renting—whether you are a property owner seeking reliable tenants or a tenant looking for the perfect space. Our comprehensive rental services ensure transparency, convenience, and complete peace of mind.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Rental Services" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Requirement Analysis</h3>
                            <p>We discuss your specific needs—whether it's location, budget, or amenities—to understand exactly what you are looking for.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Property Matching</h3>
                            <p>We screen our extensive database to find properties that best match your criteria, saving you time and effort.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Site Visits</h3>
                            <p>We coordinate and accompany you on property visits, helping you assess the features and suitability of each option.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Verification</h3>
                            <p>We verify property ownership and ensure all documentation is in order to protect your interests.</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Agreement</h3>
                            <p>We assist in drafting and finalizing the rental agreement, ensuring clear terms and compliance with legal standards.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Move-in Support</h3>
                            <p>We provide support during the handover process to ensure a smooth transition into your new home or office.</p>
                        </div>
                    </div>
                </div>
            </div>

            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default RentalServices;
